export default __webpack_public_path__ + "static/media/Widowdusk Fauld.1749bef1.jpg";